
  import { css } from 'lit';
  export const styles = css`:host{background:var(--header-background);color:var(--header-text-color)}`;
  